import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ProductAuth20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_899)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.25 10C0.25 4.61522 4.61522 0.25 10 0.25C15.3848 0.25 19.75 4.61522 19.75 10C19.75 15.3848 15.3848 19.75 10 19.75C4.61522 19.75 0.25 15.3848 0.25 10ZM10 1.75C5.69647 1.75 2.16255 5.04513 1.78363 9.25H11.0644L7.9697 6.15533L9.03036 5.09467L13.9283 9.99258L9.03777 15.0228L7.96228 13.9772L11.0998 10.75H1.78363C2.16255 14.9549 5.69647 18.25 10 18.25C14.5563 18.25 18.25 14.5563 18.25 10C18.25 5.44365 14.5563 1.75 10 1.75Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_899'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

ProductAuth20.displayName = 'ProductAuth20';
export default ProductAuth20;
